import React from "react";
import "./style.css";
import Aos from "aos";
import "aos/dist/aos.css";
import handleViewport from "react-in-viewport";

class Contact extends React.Component {
  constructor() {
    super();
    this.state = {
      emailCopied: false,
      emailText: "sagardalal112@gmail.com",
    };
  }
  componentDidMount() {
    Aos.init({ duration: 500, once: true });
  }
  changeEmailText = (e) => {
    if (e.type === "mouseenter" && !this.state.emailCopied) {
      this.setState({ emailText: "copy to clipboard" });
    } else if (e.type === "mouseenter" && this.state.emailCopied) {
      this.setState({ emailText: "copied to clipboard" });
    } else if (e.type === "click") {
      this.setState({ emailText: "copied to clipboard" });
      setTimeout(() => {
        this.setState({ emailText: "sagardalal112@gmail.com" });
      }, 1000);
    } else {
      this.setState({ emailText: "sagardalal112@gmail.com" });
    }
  };

  render() {
    return (
      <div className="contact" id="contact">
        <div className="contact-items">
          <div className="contact-header">
            <div data-aos="fade-in" className="contact-heading">
              <div>Get in</div>&nbsp;
              <span style={{ color: "rgb(255, 65, 31)" }}>touch</span>
            </div>
          </div>
          <div data-aos="fade-in" className="contact-body">
            I’m seeking out opportunities to collaborate with companies /
            agencies / individuals to work with them.
            <br />
            Feel free to reach out through email below:
            <br />
            <br />
            <div
              className="contact-email"
              onMouseEnter={this.changeEmailText}
              onMouseLeave={this.changeEmailText}
              onClick={(e) => {
                navigator.clipboard.writeText("sagardalal112@gmail.com");
                this.changeEmailText(e);
                this.setState({ emailCopied: true });
              }}
            >
              {this.state.emailText}
            </div>
            <br />
            <div>
              <a href="https://github.com/SagarDalal15">
                <img
                  style={{ width: "50px" }}
                  alt="Github Logo"
                  src="https://image.flaticon.com/icons/png/512/2111/2111432.png"
                ></img>
              </a>
              {"   "} &nbsp; &nbsp;
              <a href="https://www.linkedin.com/in/sagar-dalal-656022208/">
                <img
                  style={{ width: "50px" }}
                  alt="LinkedIn Logo"
                  src="https://image.flaticon.com/icons/png/512/145/145807.png"
                ></img>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
//Using Viewport
const MySection4 = handleViewport(Contact, { rootMargin: "-50%" });

export default MySection4;
